import React, { Component } from 'react';
import { Box } from '@mui/material';
import SectionTitle from './SectionTitle';
import RadioButtonGroup from '../../../../../components/RadioButtonGroup';
import { ALERT_SEVERITY } from '../../../../../components/AlertDisplay2';

export const DELIVERY_CONFIG_TYPE = {
    NO_RESTRICTION: 'ALL',
    PICKUP_ONLY: 'PICKUP_ONLY',
    DELIVERY_ONLY: 'DELIVERY_ONLY',
};

class DeliveryConfigSection extends Component {
    constructor(props) {
        super(props);

        this.deliveryTypeOptions = [
            { key: DELIVERY_CONFIG_TYPE.NO_RESTRICTION, label: 'Keine Einschränkung' },
            { key: DELIVERY_CONFIG_TYPE.PICKUP_ONLY, label: 'Nur Abholung' },
            { key: DELIVERY_CONFIG_TYPE.DELIVERY_ONLY, label: 'Nur Lieferung' },
        ];
    }

    onChange(value) {
        const { editMode, selectedDeliveryType, onDeliveryTypeChange, showAlert } = this.props;

        if (editMode) {
            if (
                selectedDeliveryType?.type === DELIVERY_CONFIG_TYPE.NO_RESTRICTION ||
                (selectedDeliveryType?.type !== value && value !== DELIVERY_CONFIG_TYPE.NO_RESTRICTION)
            ) {
                showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
                return;
            }
        }

        const newType = !editMode
            ? { type: value }
            : selectedDeliveryType?.type === value
                ? { type: selectedDeliveryType.type }
                : { type: selectedDeliveryType.type, newType: value };

        onDeliveryTypeChange?.(newType);
    }

    render() {
        const selectedKey =
            this.props.selectedDeliveryType?.newType ||
            this.props.selectedDeliveryType?.type ||
            DELIVERY_CONFIG_TYPE.NO_RESTRICTION;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={require('../../../../../assets/icons/deliveryscooter.png')}
                    label="Lieferkonfiguration"
                />

                <RadioButtonGroup
                    items={this.deliveryTypeOptions}
                    selectedKey={selectedKey}
                    onSelect={(value) => this.onChange(value)}
                />
            </Box>
        );
    }
}

export default DeliveryConfigSection;